import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    advisor: PropTypes.object,
    onBack: PropTypes.func,
    onDone: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { team } = this.context.admin
    const { advisor } = this.props
    return {
      title: 't(Change Domain)',
      method: 'PATCH',
      endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/edit`,
      action: `/api/admin/truevail/admin/advisors/${advisor.id}/domain`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Public Domain)', 
              name: 'public_domain', 
              type: 'domainfield', 
              provider_id: team.provider.id, 
              required: true 
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Edit
